import React from "react";
import "./Auth.scss";

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authContainer">
      <div className="auth_box">
        {/* <figure className="auth_logo">
          <img src="/static/images/ozri_logo.svg" alt="" />
        </figure> */}
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
